import {cn} from '@/utils';
import {useModalCloseOnOutsideClick} from '@/hooks/useModalInterface';
import React, {useRef} from 'react';
import ReactDOM from 'react-dom';

export interface ModalProps {
  isOpen: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  position?: 'center' | 'top' | 'bottom';
  backgroundColor?: string;
  closeOnOutsideClick?: boolean;
  className?: string;
  style?: React.CSSProperties;
  zIndex?: string;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  position = 'center',
  backgroundColor = 'rgba(0, 0, 0, 0.7)',
  closeOnOutsideClick = true,
  className = '',
  style,
  zIndex = 'z-50',
}) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const modalContainerRef = useRef<HTMLDivElement>(null);

  useModalCloseOnOutsideClick({
    modalRef,
    modalContainerRef,
    isOpen,
    onClose,
    closeOnOutsideClick,
  });

  return ReactDOM.createPortal(
    <div
      ref={modalContainerRef}
      className={`fixed inset-0 flex justify-center ${zIndex} ${isOpen ? 'block' : 'hidden'} ${position === 'center' ? 'items-center' : position === 'top' ? 'items-start' : 'items-end'}`}
      style={{backgroundColor}}>
      <div
        ref={modalRef}
        className={cn(['bg-white rounded-[1.25rem] shadow-lg', className])}
        style={style}>
        {children}
      </div>
    </div>,
    document.body,
  );
};

export default Modal;
